import { render, staticRenderFns } from "./WorkIconImport.vue?vue&type=template&id=0b219d4d"
import script from "./WorkIconImport.vue?vue&type=script&lang=js"
export * from "./WorkIconImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports